import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getTrainingContainer } from '../../container/training-module'
import { ITRainingService, TRAINING_SERVICE_KEY } from '../../modules/training'
import styles from './viewStyle.module.css'
import { AppButton, ButtonTheme } from '../../components/app-button/AppButton'
import { emptyTrainingDTO, TrainingDTO } from '../../modules/training/models/TrainingDTO'
import { navigate } from '@reach/router'
import { ROUTE_TRAININGS } from '../../routes/routes-constants'
import { getMediaContainer } from '../../container/media-module'
import { MediaService } from '../../modules/media/services/MediaService'
import { MEDIA_SERVICE_KEY } from '../../modules/media'
import { getImageSource, isImageUrl } from '../../common/utils/file'
import { PageLayout } from 'pages/layout'

type TrainingsViewProps = {
  id?: string
}

const trainingService = getTrainingContainer().get<ITRainingService>(TRAINING_SERVICE_KEY)
const mediaService = getMediaContainer().get<MediaService>(MEDIA_SERVICE_KEY)

export function TrainingsView(props: TrainingsViewProps) {
  const { t } = useTranslation()
  const [training, setTraining] = useState<TrainingDTO>(emptyTrainingDTO())
  const [image, setImage] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!props.id) return

    trainingService.getByID(props.id).subscribe((res) => {
      if (res) {
        setTraining(res)
        setIsLoading(false)
      }
    })
  }, [props.id])

  useEffect(() => {
    if (!training.title) return

    if (training.image && isImageUrl(training.image)) {
      setImage(training.image)
      return
    }

    mediaService.getByName(training.title).subscribe((res) => {
      if (res) {
        setImage(res.data)
      }
    })
  }, [training])

  const goBack = () => {
    navigate(ROUTE_TRAININGS)
  }

  const imageSrc = getImageSource(image)

  if (isLoading || !training) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Typography>{t('loading')}</Typography>
      </Box>
    )
  }

  return (
    <PageLayout title={t(training.title)}>
      <Box className={styles.trainingContainer}>
        <Box className={styles.description}>
          <Box>
            <p className={styles.descriptionTitle}>{`${t('description')}: `}</p>
            <p className={styles.textDescription}>{t(training.description)}</p>
          </Box>

          <Box className={styles.buttons}>
            <Box style={{ margin: 8 }}>
              <AppButton
                label={t('back')}
                theme={ButtonTheme.NewPrimary}
                handler={goBack}
                type={'button'}
              />
            </Box>
          </Box>
        </Box>

        <Box className={styles.imageContainer}>
          {imageSrc ? (
            <img
              className={styles.trainingImage}
              src={imageSrc}
              alt={t(training.title) || training.title}
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          ) : (
            <Box className={styles.noImage}>
              <Typography variant="body2" color="textSecondary">
                {t('noImageAvailable')}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </PageLayout>
  )
}
